import { mqTabletLandscape, mqTabletPortrait, mqPhone } from '../../utils/mq';

class PmsCardsBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.items = block.querySelectorAll('.pm-card');
    this.loadMoreButton = block.querySelector('.pms-cards__load-more-button');
    this.pagination = 1;

    this.calcPerPage();
    this.refresh();

    this.loadMoreButton.addEventListener('click', () => {
      this.pagination++;
      this.refresh();
    });

    mqTabletLandscape.addListener((e) => {
      this.calcPerPage();
      this.refresh();
    });
  }

  /**
   * Refresh the visibility of all job items.
   */
  refresh() {
    const foundItems = [];

    this.items.forEach((item) => {
      foundItems.push(item);
      item.classList.remove('pm-card--hidden');
    });

    for (let i = foundItems.length; i > this.pagination * this.perPage; i--) {
      foundItems[i - 1].classList.add('pm-card--hidden');
    }

    if (this.pagination * this.perPage >= foundItems.length) {
      this.loadMoreButton.classList.add('pms-cards__load-more-button--hidden');
    } else {
      this.loadMoreButton.classList.remove('pms-cards__load-more-button--hidden');
    }
  }

  /**
   * Define how many items to show.
   */
  calcPerPage() {
    if (mqPhone.matches) {
      this.perPage = 8;
    } else if (mqTabletPortrait.matches) {
      this.perPage = 6;
    } else if (mqTabletLandscape.matches) {
      this.perPage = 6;
    } else {
      this.perPage = 8;
    }
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.block .pms-cards').forEach((block) => {
  new PmsCardsBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=pms-cards', ($block, attributes) => {
    new PmsCardsBlock($block.find('.pms-cards').get(0), attributes);
  });
}